import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import FolioBuilderTabContent from "./FolioBuilderTabContent";

class FolioBuilder extends React.Component {
  constructor(props) {
    super(props)

    var self = this;

    this.buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ],
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation();
          e.preventDefault();

          self.onSave();
        }
      }
    ];

    this.state = {
      active_tab: this.props.active_tab || 'general',
      autoGenerateFolio: false,
      summary: null,
      folio_id: this.props.folio_id ? this.props.folio_id : null,
      name: this.props.name,
      folio_items: this.props.folio_items ? this.props.folio_items : null,
      folio_item_types: this.props.folio_item_types ? this.props.folio_item_types : null,
      folio_item_type_ids: this.props.folio_item_type_ids ? this.props.folio_item_type_ids : [],
      reservation_segment: this.props.reservation_segment,
      order: this.props.order,
      form_action: this.props.reservation_segment,
      folio_items_path: this.props.folio_items_path,
      reversal_folio_items_path: this.props.reversal_folio_items_path,
      payment_logs_path: this.props.payment_logs_path,
      folio_summary_path: this.props.folio_summary_path,
      folio_notes_path: this.props.folio_notes_path,
      updated_at: this.props.updated_at,
      date_format: this.props.date_format,
      time_format: this.props.time_format,
      read_only: this.props.read_only,
      loading: false,
      new_record: this.props.new_record,
      note_count: this.props.note_count || null,
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      file_group: this.props.file_group,
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeFlagged = this.onChangeFlagged.bind(this)
    this.onChangeNote = this.onChangeNote.bind(this);
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this);
    this.onChangeAutoGenerate = this.onChangeAutoGenerate.bind(this);
    this.updateNoteCount = this.updateNoteCount.bind(this);
  }

  componentDidMount() {
    var self = this;

    if (!this.props.new_record && !this.state.loading) {

      this.getSummaryData()
    }

    $(window).on("paymentSavedSuccessfully", function () {
      self.setState({ loading: true });
    });

    $(window).on("folioItemSavedSuccessfully", function () {
      self.setState({ loading: true });
    });

    $(window).on("folioItemDeletedSuccessfully", function() {
      self.setState({ loading: true});
    });

    $(window).on("folioSavedSuccessfully", function () {
      self.setState({ loading: true });
    })

    $(window).on("folioDeletedSuccessfully", function () {
      self.setState({ loading: true });
    })



  }

  componentDidUpdate() {
    // if (this.state.loading && !this.props.new_record) {
    //   this.getSummaryData();
    // }
  }


  getSummaryData() {
    var self = this;
    this.setState({ loading: true });

    $.ajax({
      type: 'POST',
      url: self.props.folio_summary_data_path,
      data: {
      }
    }).done((data) => {

      self.setState({
        loading: false,
        summary: data
      });


    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({
          errors: data.responseJSON,
          loading: false
        });

        $('modal-body').scrollTop(0);
      }

    });
    self.setState({
      loading: false
    })


  }


  render() {
    return (
      <div className="folio-builder">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={this.buttons} />
          <FolioBuilderTabContent {...this.state}
            onChange={this.onChange}
            onChangeNote={this.onChangeNote}
            onChangeFileUploadGroup={this.onChangeFileUploadGroup}
            onChangeFlagged={this.onChangeFlagged}
            updateNoteCount={this.updateNoteCount}
            buttons={this.buttons}
            onChangeSettledSwitch={this.onChangeSettledSwitch}
            onChangeAutoGenerate={this.onChangeAutoGenerate}
            ota_folio={this.props.ota_folio}
          />

        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  tabs() {
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.active_tab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        }
      ]
    );
  };

  /******************
  * Change handlers *
  *******************/


  onChange(event) {
    if (event && event.target) {
      //console.log('onChange!', event.target.name, event.target.value);
      this.state[event.target.name] = event.target.value;
      this.forceUpdate();
    }
  }

  onChangeFileUploadGroup(file_group) {
    this.setState({file_group: file_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj);
      note_obj.note = noteText;

      this.setState({
        note_obj: note_obj
      });
    };
  };

  updateNoteCount(count) {
    this.setState({
      note_count: count,
    });
  };

  onChangeFlagged(event) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event
    this.setState({ note_obj: note_obj });
  };


  onChangeActiveTab(active_tab) {
    this.setState({ active_tab: active_tab });
  };


  onChangeAutoGenerate(e) {
    this.setState({
      autoGenerateFolio: e.target.checked,
    });
  };

  onSave() {
    this.setState({ loading: true });

    var params = this.prepParams();
    $.ajax({
      type: this.props.new_record ? 'POST' : 'PUT',
      url: this.props.new_record ? this.props.new_folio_action : this.props.edit_folio_action,
      data: params
    }).done((data) => {



      this.setState({ loading: false });
      if (parent && parent.refresh_data) {
        if (this.props.new_record == true) {
          parent.refresh_data(I18n.t('folio_created_successfully'));
        } else {
          parent.refresh_data(I18n.t('folio_saved_successfully'));
        }
      };
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      };
    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({ errors: data.responseJSON, loading: false });
        $('modal-body').scrollTop(0);
      }
    });
  }

  /*******************
  * Helper functions *
  ********************/

  prepParams() {
    if (this.state.note_obj.note) {
      var note_obj = this.state.note_obj;
    };

    var params = {
      folio: {
        name: this.state.name,
        reservation_segment_id: this.state.reservation_segment ? this.state.reservation_segment.id : null,
        order_id: this.state.order ? this.state.order.id : null,
        settled_at: this.state.settled === true ? new Date : null,
      },
      generate_new_folio: this.state.autoGenerateFolio,
      note: note_obj || null,
      file_group_files: this.state.file_group && this.state.file_group.file_uploads ? this.state.file_group.file_uploads.map(file => file.id) : null,
    };
    return params
  };
};

export default FolioBuilder
